define('apps/admin/views/license-products',[
    'apps/admin/views/license-product'
    ], function(LicenseProductView) {
        'use strict';

        return Mn.CollectionView.extend({

            "collection": new Backbone.Collection(),

            "tagName": "tbody",

            "className": "license-products",

            "childView": LicenseProductView,

            "events": {
                "click .remove-product-button": "removeProduct"
            },

            "removeProduct": function(e){
                e.preventDefault();
                var productId = $(e.currentTarget).data('id');
                this.collection.remove({'id': productId});
            },

        });
});

